'use strict';

exports.partionedPointInTimeModifyResponse = partionedPointInTimeModifyResponse;

function partionedPointInTimeModifyResponse(context, config, next) {
    var model = context.apiMergedResponse,
      computedModel = {};
    computedModel[config.dataKey] = model[config.dataKey];

    context.chartData = computedModel;
    next();
}